export enum CustomTableClassNames {
  AlignStart = 'custom-table_align-start',
  CursorDisablePointerRow = 'disable-pointer',
}

interface BodyCells {
  cell: string | JSX.Element;
  id?: string | number;
}

export interface TableBodyCell {
  id: number | string;
  label?: string | JSX.Element;
  bodyCells: (string | JSX.Element)[] | BodyCells[];
  isDisabled?: boolean;
  history?: JSX.Element;
  className?: string;
  isCollapsibleButton?: boolean;
  isVerticalAlignCells?: boolean;
}

export interface CustomTable {
  tableHead: string[] | JSX.Element[];
  tableBodyCells?: TableBodyCell[];
  className?: CustomTableClassNames | string;
  caption?: string | JSX.Element;
  isAutoResizeEmptyPaginationRows?: boolean;
  isCollapsibleButton?: boolean;
  isVerticalAlignCells?: boolean;
}
